import type { GroupedFilterValues, SimpleFilterValue } from '../api/rest/types';

/** Remove any duplicate value groups (by name, merging their values with the preceding group of the same name) or filter values (by id) */
export function ensureUniqueness<T extends SimpleFilterValue>(
  groupedValues: GroupedFilterValues<T>[],
) {
  const groupLookup = new Map<string | undefined, GroupedFilterValues<T>>();
  const seenValueIds = new Set<string>();

  return groupedValues.reduce((uniqueGroupedValues, group) => {
    const { groupName, values } = group;

    const uniqueValues = values.filter((value) => {
      if (seenValueIds.has(value.id)) {
        return false;
      }

      seenValueIds.add(value.id);

      return true;
    });

    if (groupLookup.has(groupName)) {
      const existingGroup = groupLookup.get(groupName);

      existingGroup?.values?.push(...uniqueValues);
    } else {
      const deduplicatedGroup = { groupName, values: uniqueValues };
      groupLookup.set(groupName, deduplicatedGroup);
      uniqueGroupedValues.push(deduplicatedGroup);
    }

    return uniqueGroupedValues;
  }, [] as GroupedFilterValues<T>[]);
}
